'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSocketManager = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Util


// Selectors


// Constants


var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _socketActions = require('./socketActions');

var _lodash = require('lodash');

var _fp = require('lodash/fp');

var _elementService = require('../../element/elementService');

var _elementHelper = require('../../../common/elements/elementHelper');

var _permissionsService = require('../permissions/permissionsService');

var _getClientConfig = require('../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _currentUserSelector = require('../../user/currentUserSelector');

var _elementConstants = require('../../../common/elements/elementConstants');

var ELEMENT_ACTION_TYPE = _interopRequireWildcard(_elementConstants);

var _selectionConstants = require('../../../common/elements/selectionConstants');

var ELEMENT_SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

var _socketConstants = require('./socketConstants');

var _permissionConstants = require('../../../common/permissions/permissionConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var clientConfig = (0, _getClientConfig2.default)();
var apiRoot = clientConfig.apiRoot || '/';

var createSocketClient = function createSocketClient(userId) {
    if (process.env.APPLICATION_MODE === 'electron') {
        return (0, _socket2.default)(apiRoot.replace('https', 'wss').replace('http', 'ws'), {
            query: 'userId=' + userId,
            transports: ['websocket', 'polling']
        });
    }

    return (0, _socket2.default)({ query: 'userId=' + userId });
};

var SocketManager = function () {
    function SocketManager() {
        var _this = this;

        _classCallCheck(this, SocketManager);

        this.getClosestBoardChannel = function (elementId) {
            return _this.useBoardChannelIfValid((0, _elementHelper.getClosestUpBoardId)(_this.getElements(), elementId));
        };

        this.getElementIdsOfInterestFromMoveDetails = function (move) {
            return [move.location.parentId, move.from.parentId];
        };

        this.getChannelsFromMoveElementIdsOfInterest = function (elementIds) {
            return (0, _lodash.compact)((0, _lodash.uniq)(elementIds).map(_this.getClosestBoardChannel));
        };

        this.getChannelsFromMultiMoveAction = (0, _lodash.flow)((0, _fp.get)('moves'), (0, _fp.flatMap)(this.getElementIdsOfInterestFromMoveDetails), this.getChannelsFromMoveElementIdsOfInterest);

        this.socketClient = null;
        this.store = null;
        this.dispatch = null;
        this.queuedActions = [];
        this.userId = null;
    }

    _createClass(SocketManager, [{
        key: 'connectSocket',
        value: function connectSocket(userId) {
            var _this2 = this;

            this.userId = userId || this.userId;

            this.socketClient = createSocketClient(this.userId);

            this.socketClient.on('action', function (action) {
                // if it's an action that requires loaded element actions
                if (action.type === ELEMENT_ACTION_TYPE.ELEMENT_MOVE_MULTI) {
                    _this2.fetchUnknownElements(action.moves.map(function (move) {
                        return move.id;
                    }));
                }

                if (action.type === ELEMENT_ACTION_TYPE.ELEMENT_UPDATE) {
                    _this2.fetchUnknownElements(action.updates.map(function (update) {
                        return update.id;
                    }));
                }

                _this2.dispatch(action);
            });

            this.socketClient.on('connect', function () {
                var state = _this2.store.getState();
                _this2.updateChannels({
                    joined: state.getIn(['app', 'socketConnection', 'channels']).toJS(),
                    left: []
                });

                _this2.dispatch((0, _socketActions.socketConnect)());

                _this2.queuedActions.forEach(function (queued) {
                    return _this2.socketEmit(queued.eventName, queued.action);
                });
                _this2.queuedActions = [];
            });

            this.socketClient.on('disconnect', function () {
                _this2.dispatch((0, _socketActions.socketDisconnect)());
            });
        }
    }, {
        key: 'fetchUnknownElements',
        value: function fetchUnknownElements(ids) {
            var _this3 = this;

            var elementIdsToFetch = ids.filter(function (id) {
                var el = _this3.store.getState().getIn(['elements', id]);
                return !el || !el.get('id') || (0, _elementHelper.isSkeleton)(el);
            });

            if (elementIdsToFetch.length) {
                this.dispatch((0, _elementService.fetchElements)({ elementIds: elementIdsToFetch, force: true }));
            }
        }
    }, {
        key: 'getElements',
        value: function getElements() {
            return this.store.getState().get('elements');
        }
    }, {
        key: 'validateSavePermissions',
        value: function validateSavePermissions(elementId) {
            var userId = (0, _currentUserSelector.getCurrentUserId)(this.store.getState());
            return (0, _permissionsService.confirmedValidPermissions)(this.getElements(), elementId, userId, _permissionConstants.ACCESS_BITS.SAVE);
        }

        /**
         * Will only return the element ID as a channel if the user has save permissions.
         */

    }, {
        key: 'useBoardChannelIfValid',
        value: function useBoardChannelIfValid(elementId) {
            return this.validateSavePermissions(elementId) ? elementId : undefined;
        }
    }, {
        key: 'getAncestorBoardChannel',
        value: function getAncestorBoardChannel(elementId) {
            return this.useBoardChannelIfValid((0, _elementHelper.getClosestAncestorBoardId)(this.getElements(), elementId));
        }
    }, {
        key: 'getChannelsFromActionParentId',
        value: function getChannelsFromActionParentId(syncAction) {
            return [this.useBoardChannelIfValid(syncAction.location.parentId)];
        }
    }, {
        key: 'getChannelsFromActionsAncestorBoard',
        value: function getChannelsFromActionsAncestorBoard(elementId) {
            return [this.getAncestorBoardChannel(elementId)];
        }
    }, {
        key: 'getChannelsFromSingleElementUpdate',
        value: function getChannelsFromSingleElementUpdate(elementId) {
            // TODO Don't always need to send updates to the parent channel (e.g. if board inbox state changes)
            // Always send the update to the element's board ancestor channel
            var channels = this.getChannelsFromActionsAncestorBoard(elementId);

            var state = this.store.getState();
            var element = state.getIn(['elements', elementId]);

            // If the element is a board then also send it to that board's channel too
            if ((0, _elementHelper.isBoard)(element)) {
                var boardChannel = this.useBoardChannelIfValid(elementId);
                boardChannel && channels.push(boardChannel);
            }

            return channels;
        }
    }, {
        key: 'getChannelsFromMultipleElementUpdateAction',
        value: function getChannelsFromMultipleElementUpdateAction(syncAction) {
            var _this4 = this;

            return (0, _lodash.uniq)((0, _fp.flatMap)(function (update) {
                return _this4.getChannelsFromSingleElementUpdate(update.id);
            }, syncAction.updates));
        }
    }, {
        key: 'getChannelsFromShareAction',
        value: function getChannelsFromShareAction(action) {
            return [action.userId, action.user._id];
        }
    }, {
        key: 'getChannelsFromSelectionAction',
        value: function getChannelsFromSelectionAction(syncAction) {
            var firstSelectedId = (0, _lodash.head)(syncAction.ids);
            var selectionChannel = this.getAncestorBoardChannel(firstSelectedId);
            return selectionChannel ? ['' + selectionChannel + _socketConstants.LIVE_ACTIVITY_SUFFIX] : [];
        }
    }, {
        key: 'getChannelsFromUserAction',
        value: function getChannelsFromUserAction(action) {
            return [action.userId || action.user && action.user._id];
        }

        /**
         * Gets the socket channels relevant for the given action.
         */

    }, {
        key: 'getActionChannels',
        value: function getActionChannels(syncAction) {
            switch (syncAction.type) {
                case ELEMENT_ACTION_TYPE.ELEMENT_CREATE:
                case ELEMENT_ACTION_TYPE.ELEMENT_DELETE:
                    return this.getChannelsFromActionParentId(syncAction);
                case ELEMENT_ACTION_TYPE.ELEMENT_UPDATE:
                    return this.getChannelsFromMultipleElementUpdateAction(syncAction);
                case ELEMENT_ACTION_TYPE.ELEMENT_SET_TYPE:
                    return this.getChannelsFromActionsAncestorBoard(syncAction.id);
                case ELEMENT_ACTION_TYPE.ELEMENT_MOVE_MULTI:
                    return this.getChannelsFromMultiMoveAction(syncAction);
                case ELEMENT_SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
                case ELEMENT_SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED:
                case ELEMENT_SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL:
                    return this.getChannelsFromSelectionAction(syncAction);
                case ELEMENT_ACTION_TYPE.ELEMENT_SHARE:
                case ELEMENT_ACTION_TYPE.ELEMENT_UNSHARE:
                    return this.getChannelsFromShareAction(syncAction);
                default:
                    return this.getChannelsFromUserAction(syncAction);
            }
        }

        /**
         * Connect to all channels passed in here to ensure we can receive messages.
         * Only validate whether we should send messages when sending.
         */

    }, {
        key: 'updateChannels',
        value: function updateChannels(_ref) {
            var joined = _ref.joined,
                left = _ref.left;

            this.socketEmit('update-channels', {
                joined: joined,
                left: left
            });
        }
    }, {
        key: 'disconnectSocket',
        value: function disconnectSocket() {
            this.socketClient.io.disconnect();
        }
    }, {
        key: 'emitAction',
        value: function emitAction(syncAction) {
            this.socketEmit('action', _extends({}, syncAction, {
                channels: (0, _lodash.compact)(this.getActionChannels(syncAction))
            }));
        }
    }, {
        key: 'socketEmit',
        value: function socketEmit(eventName, action) {
            if (!this.socketClient) return this.queuedActions.push({ eventName: eventName, action: action });

            this.socketClient.emit(eventName, action);
        }
    }, {
        key: 'subscribeToStore',
        value: function subscribeToStore(store) {
            this.store = store;
            this.dispatch = this.store.dispatch.bind(this.store);
        }
    }]);

    return SocketManager;
}();

var getSocketManager = exports.getSocketManager = function getSocketManager() {
    return new SocketManager();
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/socketClient.js
// module id = 2142
// module chunks = 0